// File: frontend/src/components/layout/Navbar.js (FINAL UPDATED: With AuthContext)

import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa'; 
import { useLanguage } from '../../context/LanguageContext';
import { useAuth } from '../../context/AuthContext'; // <--- NEW: Import AuthContext

import logoImage from '../../assets/images/logo.jpg';

export const menuItems = [
  { name: 'Home', path: '/' },
  {
    name: 'National',
    path: '/category/national',
    submenu: [
      { name: 'Delhi', path: '/category/national/delhi' },
      { name: 'Bihar', path: '/category/national/bihar' },
      { name: 'Maharastra', path: '/category/national/maharastra' },
      { 
        name: 'Uttar Pradesh', 
        path: '/category/national/uttar-pradesh',
        submenu: [
          { name: 'Agra', path: '/category/national/uttar-pradesh/agra' },
          { name: 'Amethi', path: '/category/national/uttar-pradesh/amethi' },
          { name: 'Ayodhya', path: '/category/national/uttar-pradesh/ayodhya' },
          { name: 'Barabanki', path: '/category/national/uttar-pradesh/barabanki' },
          { name: 'Bareilly', path: '/category/national/uttar-pradesh/bareilly' },
          { name: 'Basti', path: '/category/national/uttar-pradesh/basti' },
          { name: 'Bhadohi', path: '/category/national/uttar-pradesh/bhadohi' },
          { name: 'Bijnor', path: '/category/national/uttar-pradesh/bijnor' },
          { name: 'Budaun', path: '/category/national/uttar-pradesh/budaun' },
          { name: 'Noida', path: '/category/national/uttar-pradesh/noida' },
          { name: 'Ghaziabad', path: '/category/national/uttar-pradesh/ghaziabad' },
          { name: 'Gorakhpur', path: '/category/national/uttar-pradesh/gorakhpur' },
          { name: 'Hardoi', path: '/category/national/uttar-pradesh/hardoi' },
          { name: 'Haridwar', path: '/category/national/uttar-pradesh/haridwar' },
          { name: 'Kanpur', path: '/category/national/uttar-pradesh/kanpur' },
          { name: 'Lakhimpur Kheri', path: '/category/national/uttar-pradesh/lakhimpur-kheri' },
          { name: 'Lucknow', path: '/category/national/uttar-pradesh/lucknow' },
          { name: 'Mathura', path: '/category/national/uttar-pradesh/mathura' },
          { name: 'Moradabad', path: '/category/national/uttar-pradesh/moradabad' },
          { name: 'Pilibhit', path: '/category/national/uttar-pradesh/pilibhit' },
          { name: 'Shahjahanpur', path: '/category/national/uttar-pradesh/shahjahanpur' },
          { name: 'Sitapur', path: '/category/national/uttar-pradesh/sitapur' },
          { name: 'Varanasi', path: '/category/national/uttar-pradesh/varanasi' }
        ]
      }, 
      { name: 'Uttrakhand', path: '/category/national/uttrakhand' },
      { name: 'Chhattisgarh', path: '/category/national/chhattisgarh' },
      { name: 'Gujarat', path: '/category/national/gujarat' },
      { name: 'Madhya Pradesh', path: '/category/national/madhya-pradesh' },
      { name: 'Haryana', path: '/category/national/haryana' },
      { name: 'Punjab', path: '/category/national/punjab' },
      { name: 'Rajasthan', path: '/category/national/rajasthan' },
      { name: 'West Bengal', path: '/category/national/west-bengal' }
    ]
  },
  {
    name: 'World',
    path: '/category/world',
    submenu: [
      { name: 'Environment', path: '/category/world/environment' },
      { name: 'Tech', path: '/category/world/tech' }
    ]
  },
  { name: 'Politics', path: '/category/politics' },
  { name: 'Business', path: '/category/business' },
  { name: 'Entertainment', path: '/category/entertainment' },
  { name: 'Sports', path: '/category/sports' },
  {
    name: 'Education',
    path: '/category/education',
    submenu: [
      { name: 'Jobs', path: '/category/education/jobs' }
    ]
  },
  { name: 'Health', path: '/category/health' },
  { name: 'Religion', path: '/category/religion' },
  { name: 'Crime', path: '/category/crime' },
  { name: 'Poetry Corner', path: '/category/poetry-corner' },
];

const Navbar = () => {
  // 1. HOOKS
  const { t, i18n } = useTranslation();
  const { language, toggleLanguage } = useLanguage();
  const navigate = useNavigate();
  
  // --- NEW: Consume Auth Context ---
  const { user, logout } = useAuth(); 
  // ---------------------------------

  // 2. STATES
  const [searchQuery, setSearchQuery] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openMobileSubmenu, setOpenMobileSubmenu] = useState(null); 
  const [openMobileChildSubmenu, setOpenMobileChildSubmenu] = useState(null); 
  
  // Time State
  const [currentTime, setCurrentTime] = useState(new Date());

  // --- REPLACEMENT: Get status directly from Context (Reactive) ---
  // Pehle hum useEffect se local state set karte the, ab hum derived state use karenge
  const isLoggedIn = !!user;       // Agar user object hai to logged in true
  const userRole = user?.role;     // User ka role (admin/editor)
  // ---------------------------------------------------------------

  // Clock Timer
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // 4. HELPER FUNCTIONS
  const formatDateTime = () => {
      const locale = language === 'hi' ? 'hi-IN' : 'en-IN';
      const dateOptions = { timeZone: 'Asia/Kolkata', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
      const timeOptions = { timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true };
      
      return {
          dateStr: currentTime.toLocaleDateString(locale, dateOptions),
          timeStr: currentTime.toLocaleTimeString(locale, timeOptions)
      };
  };
  
  const { dateStr, timeStr } = formatDateTime();

  const handleLanguageToggle = (lang) => {
    i18n.changeLanguage(lang);
    toggleLanguage();
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${searchQuery}`);
      setSearchQuery('');
      setIsMobileMenuOpen(false);
    }
  };

  // --- UPDATED LOGOUT FUNCTION ---
  const handleLogout = () => {
    logout(); // Context ka logout use karein (ye localStorage clear kar dega)
    setIsMobileMenuOpen(false);
    navigate('/');
  };
  // -------------------------------

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setOpenMobileSubmenu(null);
    setOpenMobileChildSubmenu(null);
  };

  const checkActive = (match, location, item) => {
    if (match) return true;
    if (item.submenu) {
      for (let sub of item.submenu) {
        if (location.pathname.startsWith(sub.path)) return true;
        if (sub.submenu) {
          for (let deep of sub.submenu) {
             if (location.pathname.startsWith(deep.path)) return true;
          }
        }
      }
    }
    return false;
  };

  return (
    <header className="main-header">

      {/* --- TOP BAR --- */}
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-content">

            <NavLink to="/" className="nav-logo" onClick={closeMobileMenu}>
              <img src={logoImage} alt="India Jagran Logo" className="navbar-logo-image" />
            </NavLink>

            <form onSubmit={handleSearchSubmit} className="search-bar expanded-search">
              <input
                type="text"
                placeholder={t('Search news, topics...')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="search-icon-btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </button>
            </form>

            <div className="nav-actions-right">

              {/* Date Time Widget */}
              <div className="nav-date-time-widget">
                  <span className="nav-date">{dateStr}</span>
                  <span className="nav-time">{timeStr}</span>
              </div>

              <NavLink to="/subscribe" className="nav-subscribe-btn">{t('subscribe')}</NavLink>
              
              <div className="language-switcher">
                {language === 'en' ? (
                  <button onClick={() => handleLanguageToggle('hi')}>HI</button>
                ) : (
                  <button onClick={() => handleLanguageToggle('en')}>EN</button>
                )}
              </div>

              {/* --- UPDATE: Role Based Links (Desktop) --- */}
              <div className="nav-user-actions">
                {isLoggedIn ? (
                  <>
                    {userRole === 'admin' ? (
                        <NavLink to="/admin" className="nav-admin-link">{t('dashboard')}</NavLink>
                    ) : (
                        <NavLink to="/admin/editor" className="nav-admin-link">
                            {language === 'hi' ? 'नया लेख' : 'New Article'}
                        </NavLink>
                    )}
                    <button onClick={handleLogout} className="nav-logout-btn">{t('logout')}</button>
                  </>
                ) : (
                  <NavLink to="/admin/login" className="nav-admin-link">{t('admin_login')}</NavLink>
                )}
              </div>
              {/* ---------------------------------------- */}
            </div>

            <div className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(true)}>
              <FaBars />
            </div>

          </div>
        </div>
      </div>

      {/* --- CATEGORY NAV BAR (Unchanged) --- */}
      <nav className="category-nav">
        <div className="container">
          <ul className="nav-menu">
            {menuItems.map((item, index) => (
              <li key={index} className="nav-item">
                <NavLink
                  to={item.path}
                  className="nav-link"
                  isActive={(match, location) => checkActive(match, location, item)}
                >
                  {t(item.name)}
                  {item.submenu && item.submenu.length > 0 && <span className="arrow-down"></span>}
                </NavLink>

                {item.submenu && item.submenu.length > 0 && (
                  <ul className="submenu">
                    {item.submenu.map((subItem, subIndex) => (
                      <li key={subIndex} className="submenu-item">
                        <NavLink to={subItem.path} className="submenu-link">
                          {t(subItem.name)}
                          {subItem.submenu && subItem.submenu.length > 0 && <span className="arrow-right"> ›</span>}
                        </NavLink>

                        {subItem.submenu && subItem.submenu.length > 0 && (
                          <ul className="submenu-level-3">
                            {subItem.submenu.map((deepItem, deepIndex) => (
                              <li key={deepIndex}>
                                <NavLink to={deepItem.path} className="submenu-link">
                                  {t(deepItem.name)}
                                </NavLink>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* --- MOBILE MENU --- */}
      <div className={`mobile-nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>

        <div className="mobile-menu-header">
          <NavLink to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img src={logoImage} alt="India Jagran Logo" className="navbar-logo-image mobile" />
          </NavLink>
          <button className="mobile-menu-close" onClick={closeMobileMenu}><FaTimes /></button>
        </div>

        <div className="mobile-date-display">
            <span>{dateStr}</span> | <span style={{color: '#e85f18', fontWeight: 'bold'}}>{timeStr}</span>
        </div>

        <form onSubmit={handleSearchSubmit} className="search-bar mobile-search expanded-search">
          <input
            type="text"
            placeholder={t('Search...')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button type="submit" className="search-icon-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
          </button>
        </form>

        <ul className="mobile-nav-links">
          {menuItems.map((item, index) => (
            <li key={index} className="mobile-nav-item">
              <div className="mobile-link-wrapper">
                <NavLink 
                  to={item.path} 
                  className="mobile-nav-link" 
                  onClick={closeMobileMenu}
                >
                  {t(item.name)}
                </NavLink>
                {item.submenu && item.submenu.length > 0 && (
                  <span 
                    className={`mobile-arrow ${openMobileSubmenu === index ? 'open' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setOpenMobileSubmenu(openMobileSubmenu === index ? null : index);
                    }}
                  >▼</span>
                )}
              </div>

              {item.submenu && item.submenu.length > 0 && openMobileSubmenu === index && (
                <ul className="mobile-submenu">
                  {item.submenu.map((subItem, subIndex) => (
                    <li key={subIndex} className="mobile-submenu-item">
                      <div className="mobile-link-wrapper">
                         <NavLink
                          to={subItem.path}
                          className="mobile-submenu-link"
                          onClick={closeMobileMenu}
                        >
                          {t(subItem.name)}
                        </NavLink>
                        {subItem.submenu && subItem.submenu.length > 0 && (
                           <span 
                             className={`mobile-arrow ${openMobileChildSubmenu === subIndex ? 'open' : ''}`}
                             onClick={(e) => {
                               e.stopPropagation();
                               setOpenMobileChildSubmenu(openMobileChildSubmenu === subIndex ? null : subIndex);
                             }}
                           >▼</span>
                        )}
                      </div>

                      {subItem.submenu && subItem.submenu.length > 0 && openMobileChildSubmenu === subIndex && (
                        <ul className="mobile-submenu deep-submenu">
                          {subItem.submenu.map((deepItem, deepIndex) => (
                            <li key={deepIndex} className="mobile-submenu-item">
                              <NavLink
                                to={deepItem.path}
                                className="mobile-submenu-link"
                                onClick={closeMobileMenu}
                              >
                                -- {t(deepItem.name)}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>

        <div className="mobile-nav-actions">
          <NavLink to="/subscribe" className="nav-subscribe-btn" onClick={closeMobileMenu}>{t('subscribe')}</NavLink>
          
          {/* --- UPDATE: Role Based Links (Mobile) --- */}
          <div className="nav-user-actions">
            {isLoggedIn ? (
              <>
                {userRole === 'admin' ? (
                    <NavLink to="/admin" className="nav-admin-link" onClick={closeMobileMenu}>{t('dashboard')}</NavLink>
                ) : (
                    <NavLink to="/admin/editor" className="nav-admin-link" onClick={closeMobileMenu}>
                        {language === 'hi' ? 'नया लेख' : 'New Article'}
                    </NavLink>
                )}
                <button onClick={handleLogout} className="nav-logout-btn">{t('logout')}</button>
              </>
            ) : (
              <NavLink to="/admin/login" className="nav-admin-link" onClick={closeMobileMenu}>{t('admin_login')}</NavLink>
            )}
          </div>
          {/* ----------------------------------------- */}

          <div className="language-switcher">
             <button onClick={() => handleLanguageToggle(language === 'en' ? 'hi' : 'en')}>
                {language === 'en' ? 'Switch to Hindi' : 'Switch to English'}
             </button>
          </div>
        </div>
      </div>

    </header>
  );
};

export default Navbar;